module.exports = __webpack_public_path__ + "img/zjt.145ba085.jpg";